import { DOCUMENT } from '@angular/common';
import { ServerConfigService } from './../../../../share/service/server-config.service';
import { Component, AfterViewInit, ViewChild, ViewContainerRef, Input, Inject, ElementRef } from '@angular/core';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { ABSTRACT_TEMPLATE_TOKEN, AbstractTemplate } from 'src/app/web-generator/template-generator/abstract-template';
import { Section } from 'src/app/web-generator/template-generator/entity/section';
import { IndexSectionLoaderService } from '../../service/index-section-loader.service';

@Component({
  selector: 'app-section-generator',
  templateUrl: './section-generator.component.html',
  styleUrls: ['./section-generator.component.scss']
})
export class SectionGeneratorComponent implements AfterViewInit {
  @Input() section: Section;
  @ViewChild('container', { read: ViewContainerRef, static: false }) container: ViewContainerRef;
  private hasAskLoadCmp = false;
  intersectionObserver: IntersectionObserver;

  constructor(
    private indexSectionLoader: IndexSectionLoaderService,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    private el: ElementRef,
    private serverConfigService: ServerConfigService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  ngAfterViewInit() {
    this.rendEmptyHeight();

    if ((!this.serverConfigService.isBrowser && global['isBot'])
    || (this.serverConfigService.isBrowser && this.serverConfigService.isEditModeUrl)
    || (this.section.data.index < 2)) {
      this.rendCmp();
    } else if (this.serverConfigService.isBrowser) {
      this.intersectionObserver = new IntersectionObserver(this.rendCmpBeforeViewing, {
        rootMargin: '50px',
        threshold: 0,
      });
      this.intersectionObserver.observe(this.el.nativeElement);
    }
  }

  /** 載入並繪製組件 */
  private rendCmp() {
    this.hasAskLoadCmp = true;
    this.indexSectionLoader.load(this.section.selector, this.container, this.section).then(cmpRef => {
      cmpRef.instance.editable = this.serverConfigService.isEditModeUrl;
      (this.el.nativeElement as HTMLElement).style.height = '';
    });
  }

  /** 在畫面滾動到要顯示它的位置時繪製組件 */
  rendCmpBeforeViewing = (entries, observer) => {
    if (this.hasAskLoadCmp) { return; }
    if (entries[0].isIntersecting) {
      this.hasAskLoadCmp = true;
      this.indexSectionLoader.load(this.section.selector, this.container, this.section).then(cmpRef => {
        cmpRef.instance.editable = this.serverConfigService.isEditModeUrl;
        (this.el.nativeElement as HTMLElement).style.height = '';
        this.intersectionObserver.unobserve(this.el.nativeElement);
      });
    }
  }

  /** 繪製空白的保留位 */
  private rendEmptyHeight() {
    if (!this.section.data.enable) { return; }

    let totalH = 600;
    const bodyWidth = this.document.body.offsetWidth;
    switch (this.section.selector) {
      case 'index-collection-01':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 20;
          contentH = (bodyWidth - 140) / 5 * 98 / 100 * 112.5 / 100 + 30 + 60;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 20;
          contentH = (bodyWidth - 140) / 5 * 98 / 100 * 112.5 / 100 + 30 + 60;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 30;
          contentH = (bodyWidth - 30 - 140) / 4 * 98 / 100 * 112.5 / 100 + 30 + 60;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 73;
          subTitleH = 51.8;
          secPaddingH = 30;
          contentH = (bodyWidth - 30) / 4 * 98 / 100 * 112.5 / 100 + 30 + 60;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 51.8;
          secPaddingH = 30;
          contentH = (bodyWidth - 30) / 3 * 98 / 100 * 112.5 / 100 + 30 + 60;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 51.8;
          secPaddingH = 30;
          contentH = (bodyWidth - 30) / 2 * 98 / 100 * 112.5 / 100 + 60;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH;
      }
      break;
      case 'index-subject-01':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 20;
          moreBtnH = 0;
          contentH = (bodyWidth / 4 - 1) * 68 / 100 + 54 + 30;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 20;
          moreBtnH = 0;
          contentH = (bodyWidth / 4 - 1) * 68 / 100 + 54 + 30;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 30;
          moreBtnH = 0;
          contentH = ((bodyWidth - 30) / 4 - 1) * 68 / 100 + 54 + 30;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30;
          moreBtnH = 0;
          contentH = ((bodyWidth - 30) / 4 - 1) * 68 / 100 + 54 + 30;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30;
          moreBtnH = 61;
          contentH = ((bodyWidth - 30) / 2 - 1) * 68 / 100 + 54 + 20;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30;
          moreBtnH = 61;
          contentH = (bodyWidth - 30 - 1) * 68 / 100 + 54 + 20;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-subject-02':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 20 + 90;
          moreBtnH = 81;
          contentH = 96.4 + 30;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 20 + 90;
          moreBtnH = 81;
          contentH = 96.4 + 30;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 30 + 90;
          moreBtnH = 81;
          contentH = 96.4 + 30;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 30 + 90;
          moreBtnH = 81;
          if (this.section.data['imageNaturalHeight']) {
            contentH = 96.4 + 30 + (bodyWidth - 60) * this.section.data['imageNaturalHeight'] / this.section.data['imageNaturalWidth'];
          } else {
            contentH = 96.4 + 30 + (bodyWidth - 60) * 2 / 3;
          }
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 38.8;
          secPaddingH = 30 + 90;
          moreBtnH = 81;
          if (this.section.data['imageNaturalHeight']) {
            contentH = 96.4 + 30 + (bodyWidth - 60) * this.section.data['imageNaturalHeight'] / this.section.data['imageNaturalWidth'];
          } else {
            contentH = 96.4 + 30 + (bodyWidth - 60) * 2 / 3;
          }
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 38.8;
          secPaddingH = 30 + 90;
          moreBtnH = 81;
          if (this.section.data['imageNaturalHeight']) {
            contentH = 96.4 + 30 + (bodyWidth - 60) * this.section.data['imageNaturalHeight'] / this.section.data['imageNaturalWidth'];
          } else {
            contentH = 96.4 + 30 + (bodyWidth - 60) * 2 / 3;
          }
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-subject-03':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 20 + 40;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 70 / 100 + 166 + 20;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 20 + 40;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 70 / 100 + 166 + 20;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 30 + 40;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 70 / 100 + 166 + 20;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 86;
          subTitleH = 38.8;
          secPaddingH = 30 + 40;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 70 / 100 + 166 + 20;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30 + 40;
          moreBtnH = 61;
          contentH = ((bodyWidth - 50) * 70 / 100 + 166) + ((bodyWidth - 60) / 2 * 69 / 100 + 74 + 20) * 2;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30 + 40;
          moreBtnH = 61;
          contentH = ((bodyWidth - 50) * 70 / 100 + 166) + ((bodyWidth - 60) / 2 * 69 / 100 + 74 + 20) * 2;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-subject-04':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 20 + 30;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 4 - 20) * 116 / 100 + 54 + 30;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 20 + 30;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 4 - 20) * 116 / 100 + 54 + 30;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 30 + 30;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 4 - 20) * 116 / 100 + 54 + 30;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30 + 30;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 4 - 20) * 116 / 100 + 54 + 30;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30 + 30;
          moreBtnH = 61;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 116 / 100 + 54 + 30;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 30 + 30;
          moreBtnH = 61;
          contentH = (bodyWidth * 83.33 / 100 - 20) * 116 / 100 + 54 + 30;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-subject-05':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 20 + 100;
          moreBtnH = 0;
          contentH = window.innerWidth * 19 / 100 * 116 / 100 + 64 + 60;
          totalH = secPaddingH + contentH;
          break;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 20 + 100;
          moreBtnH = 0;
          contentH = window.innerWidth * 19 / 100 * 116 / 100 + 64 + 60;
          totalH = secPaddingH + contentH;
          break;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 30 + 100;
          moreBtnH = 0;
          contentH = window.innerWidth * 19 / 100 * 116 / 100 + 64 + 60;
          totalH = secPaddingH + contentH;
          break;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 73;
          subTitleH = 53.7;
          secPaddingH = 30 + 100;
          moreBtnH = 61;
          contentH = ((bodyWidth - 30) / 4 - 20) * 116 / 100 + 20 + 64 + 60;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 53.7;
          secPaddingH = 30 + 100;
          moreBtnH = 61;
          contentH = ((bodyWidth - 30) / 2 - 20) * 116 / 100 + 20 + 64 + 60;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 53.7;
          secPaddingH = 30 + 100;
          moreBtnH = 61;
          contentH = (bodyWidth - 30 - 20) * 116 / 100 + 20 + 64 + +0;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-subject-06':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 20 + 100;
          moreBtnH = 0;
          contentH = window.innerWidth * 21.75 / 100 * 71.5 / 100 + 64 + 60;
          totalH = secPaddingH + contentH;
          break;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 20 + 100;
          moreBtnH = 0;
          contentH = window.innerWidth * 21.75 / 100 * 71.5 / 100 + 64 + 60;
          totalH = secPaddingH + contentH;
          break;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 51.8;
          secPaddingH = 30 + 100;
          moreBtnH = 0;
          contentH = window.innerWidth * 21.75 / 100 * 71.5 / 100 + 64 + 60;
          totalH = secPaddingH + contentH;
          break;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 73;
          subTitleH = 53.7;
          secPaddingH = 30 + 100;
          moreBtnH = 61;
          contentH = ((bodyWidth - 30) / 4 - 20) * 71.5 / 100 + 20 + 64 + 60;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 53.7;
          secPaddingH = 30 + 100;
          moreBtnH = 61;
          contentH = ((bodyWidth - 30) / 2 - 20) * 71.5 / 100 + 20 + 64 + 60;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 53.7;
          secPaddingH = 30 + 100;
          moreBtnH = 61;
          contentH = (bodyWidth - 30 - 20) * 71.5 / 100 + 20 + 64 + +0;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-subject-07':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let titleH, subTitleH, contentH, secPaddingH, moreBtnH;
        if (window.innerWidth >= 1200) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 20;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 56.25 / 100 + 54 + 30;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 20;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 56.25 / 100 + 54 + 30;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          titleH = 86;
          subTitleH = 53.8;
          secPaddingH = 60;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 56.25 / 100 + 54 + 30;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 60;
          moreBtnH = 0;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 56.25 / 100 + 54 + 30;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 60;
          moreBtnH = 61;
          contentH = (bodyWidth * 83.33 / 100 / 2 - 20) * 56.25 / 100 + 54 + 30;
        } else if (window.innerWidth < 576) {
          titleH = 73;
          subTitleH = 53.8;
          secPaddingH = 60;
          moreBtnH = 61;
          contentH = (bodyWidth * 83.33 / 100 - 20) * 56.25 / 100 + 54 + 30;
        }
        totalH = (this.section.data.title ?  titleH : 0) + (this.section.data.subTitle ?  subTitleH : 0) + secPaddingH + contentH + (this.section.data.showMoreButton ? moreBtnH : 0);
      }
      break;
      case 'index-quiz-01':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let contentH, secPaddingH;
        if (window.innerWidth >= 1200) {
          secPaddingH = 20;
          contentH = Math.max(246 + 215.56, 140 + 400);
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          secPaddingH = 20;
          contentH = Math.max(246 + 215.56, 140 + 400);
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          secPaddingH = 30;
          contentH = Math.max(246 + 215.56, 140 + 400);
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          secPaddingH = 30;
          contentH = Math.max(246 + 215.56, 140 + 400);
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          secPaddingH = 30;
          contentH = 138 + 156 + 60 + 400;
        } else if (window.innerWidth < 576) {
          secPaddingH = 30;
          contentH = 138 + 156 + 60 + 400;
        }
        totalH = secPaddingH + contentH;
      }
      break;
      case 'index-banner-02':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let contentH, secPaddingH;
        if (window.innerWidth >= 1200) {
          secPaddingH = 20 + 30;
          contentH = ((bodyWidth * 83.33 / 100 - 30) / 2 - 20) * 40 / 100 + 30;
        } else if (window.innerWidth > 1000 && window.innerWidth < 1200) {
          secPaddingH = 20 + 30;
          contentH = ((bodyWidth * 83.33 / 100 - 30) / 2 - 20) * 40 / 100 + 30;
        } else if (window.innerWidth >= 992 && window.innerWidth <= 1000) {
          secPaddingH = 30 + 30;
          contentH = ((bodyWidth * 83.33 / 100 - 30) / 2 - 20) * 40 / 100 + 30;
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
          secPaddingH = 30 + 30;
          contentH = ((bodyWidth - 60) / 2 - 20) * 40 / 100 + 30;
        } else if (window.innerWidth >= 576 && window.innerWidth < 768) {
          secPaddingH = 30 + 30;
          contentH = ((bodyWidth - 60) / 2 - 20) * 40 / 100 + 20;
        } else if (window.innerWidth < 576) {
          secPaddingH = 30 + 30;
          contentH = (bodyWidth - 60 - 20) * 40 / 100 + 20;
        }
        totalH = secPaddingH + contentH;
      }
      break;
      case 'index-search-01':
      {
        // tslint:disable-next-line: one-variable-per-declaration
        let contentH, secPaddingH;
        if (window.innerWidth > 1000) {
          secPaddingH = 20 + 80;
        } else {
          secPaddingH = 30 + 80;
        }

        if (window.innerWidth > 1400) {
          contentH = 80 + 10 + 52.39 + 58.8 + 49;
        } else if (window.innerWidth > 1200 && window.innerWidth <= 1400) {
          contentH = 67 + 10 + 52.39 + 58.8 + 49;
        } else if (window.innerWidth > 1000 && window.innerWidth <= 1200) {
          contentH = 53 + 10 + 52.39 + 58.8 + 49;
        } else if (window.innerWidth > 600 && window.innerWidth <= 1000) {
          contentH = 47 + 10 + 52.39 + 58.8 + 49;
        } else if (window.innerWidth > 500 && window.innerWidth <= 600) {
          contentH = 33 + 10 + 52.39 + 58.8 + 49;
        } else if (window.innerWidth > 370 && window.innerWidth <= 500) {
          contentH = 27 + 10 + 52.39 + 58.8 + 49;
        } else if (window.innerWidth <= 370) {
          contentH = 54 + 10 + 52.39 + 58.8 + 49;
        }
        totalH = secPaddingH + contentH;
      }
      break;
      default:
      break;
    }
    (this.el.nativeElement as HTMLElement).style.height = `${totalH}px`;
  }
}
